import FormattedText from './components/FormattedText';
import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import ConfirmButton from './components/ConfirmButton';
import PortalButton from './components/PortalButton';
import React from 'react';
import { usePortalQuery } from './hooks';
import { Link } from 'react-router-dom';
import { MdEdit, MdOpenInNew, MdDelete, MdSync } from 'react-icons/md';
import moment from 'moment';
import PortalLayout from './components/PortalLayout';
import { ErrorNotice, Loading, Empty, Status } from './components/Feedback';
import { usePortal, useSelecoes, usePortalContext, usePortalMutation } from './hooks';
export default function PortalHome() {
  const sync = usePortalMutation('sincronizacoes'),
    runs = usePortalQuery('sincronizacoes');
  const { base, labels } = usePortal(),
    query = useSelecoes(),
    context = usePortalContext(),
    remove = usePortalMutation((data) => 'selecoes/' + data.id, 'DELETE');
  return (
    <PortalLayout
      title="Portal de inscrições"
      description="Publique os seletivos e gerencie as inscrições dos candidatos."
    >
      <section className="card module-card module-content">
        <div className="card-body">
          <div className="portal-admin-row hidethis">
            <div>
              <h2 className="module-details-title">{labels.selections} no portal</h2>
              <p>Organize os cargos e documentos públicos de cada seleção.</p>
            </div>
            {
              <PortalButton
                className="btn btn-primary"
                disabled={!sync.allowed || sync.isLoading}
                onClick={() => sync.mutate({})}
                type="button"
              >
                <MdSync />
                Sincronizar seletivos da OnTest
              </PortalButton>
            }
          </div>
          <ErrorNotice error={query.error || remove.error || sync.error || runs.error} />
          {runs.data?.data?.slice(0, 3).map((r) => (
            <p key={r.id}>
              <Status value={r.status} /> · {moment(r.created_at).format('DD/MM/YYYY HH:mm')} ·{' '}
              {r.selections} seletivo(s), {r.positions} cargo(s){' '}
              {r.error && <span className="text-danger">{r.error}</span>}
            </p>
          ))}
          {query.isLoading ? (
            <Loading />
          ) : query.data?.length ? (
            <ResponsiveTable className="table table-striped">
              <thead>
                <tr>
                  <th>{labels.selection}</th>
                  <th>Inscrições</th>
                  <th>Situação</th>
                  <th className="hidethis">Ações</th>
                </tr>
              </thead>
              <tbody>
                {query.data.map((s) => (
                  <tr key={s.id}>
                    <td>
                      <strong><FormattedText>{s.title}</FormattedText></strong>
                      <small className="d-block">{s.positions_count} cargo(s)</small>
                    </td>
                    <td>
                      {moment(s.registration_starts_at).format('DD/MM/YYYY HH:mm')}
                      <br />
                      {moment(s.registration_ends_at).format('DD/MM/YYYY HH:mm')}
                    </td>
                    <td>
                      <Status value={s.status} />
                    </td>
                    <td className="hidethis">
                      <div className="portal-admin-actions actions-group">
                        <ConfirmButton
                          className="btn btn-danger btn-sm"
                          title="Excluir seleção sem inscrições"
                          disabled={!remove.allowed || remove.isLoading}
                          type="button"
                          message={
                            'Excluir esta seleção? Seleções com inscrições devem ser arquivadas.'
                          }
                          onConfirm={() =>
                            remove.mutate({
                              id: s.id,
                            })
                          }
                        >
                          <MdDelete />
                        </ConfirmButton>
                        <Link
                          className="bg-info icon portal-action-link hidethis"
                          title="Ver e configurar seleção"
                          to={base + '/selecoes/' + s.id}
                          aria-label="Ver e configurar seleção"
                        >
                          <MdEdit />
                        </Link>
                        {context.data?.frontend_url && (
                          <a
                            className="bg-info icon portal-action-link hidethis"
                            title="Abrir publicação no portal"
                            href={context.data.frontend_url + '/concursos/' + s.id}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Abrir publicação no portal"
                          >
                            <MdOpenInNew />
                          </a>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </ResponsiveTable>
          ) : (
            <Empty>
              Nenhum seletivo sincronizado. Habilite as inscrições na OnTest e sincronize os cargos.
            </Empty>
          )}
        </div>
      </section>
    </PortalLayout>
  );
}
